import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from '../directives/link';

@Component({
  selector: 'app-hcm',
  imports: [Link],
  templateUrl: './hcm.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './hcm.scss',
})
export class Hcm {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Historical-Critical Method`);
    this.dynamicTitle.description(`The historical-critical method is not a method that can be used to prove the historical existence of Jesus.`);
  }
}
